module.exports = __webpack_public_path__ + "media/img/logos/2023/king-a151ed04c563ddcb8e8c8fb9a3fa8415.svg";